import React from 'react'
import {
  Box,
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@material-ui/core'
import { ErrorOutline } from '@material-ui/icons'
import { makeStyles } from '@material-ui/core/styles'

import ButtonDialogClose from '../common/ButtonDialogClose'
import ButtonSubmit from '../../common/ButtonSubmit'

const useStyles = makeStyles(theme => ({
  icon: {
    fontSize: '126px',
    color: theme.palette.error.light,
  },
}))

const RemoveSubscription = ({ submitting, onClose, onConfirm }) => {
  const classes = useStyles()
  return (
    <>
      <DialogTitle>
        <ButtonDialogClose onClick={onClose} />
      </DialogTitle>
      <DialogContent>
        <Box display="flex" justifyContent="center">
          <Box textAlign="center" maxWidth="352px">
            <ErrorOutline className={classes.icon} />
            <Box marginY={3}>
              <Typography variant="h5">Are you sure you want to turn off this add-on?</Typography>
            </Box>
            <Typography>
              Your team members will lose their add-on benefits on Foodsby when your current billing
              period ends.
            </Typography>
          </Box>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Back</Button>
        <ButtonSubmit
          color="primary"
          variant="contained"
          submitting={submitting}
          onClick={onConfirm}
        >
          Confirm
        </ButtonSubmit>
      </DialogActions>
    </>
  )
}

export default RemoveSubscription
